import type { ServerError } from '@apollo/client/errors';

/**
 * True when the error is a 504 gateway timeout from the server, either at the
 * top level or nested under `networkError`.
 */
const isServerTimeoutError = (error: unknown): boolean => {
    if (!error || typeof error !== 'object') return false;

    const maybeServerError = error as ServerError;

    if (
        maybeServerError.statusCode === 504 &&
        maybeServerError.name === 'ServerError'
    )
        return true;

    const networkError = (error as { networkError?: unknown }).networkError;

    if (!networkError || typeof networkError !== 'object') return false;

    const maybeNetworkServerError = networkError as ServerError;

    return (
        maybeNetworkServerError.statusCode === 504 &&
        maybeNetworkServerError.name === 'ServerError'
    );
};

export { isServerTimeoutError };
